import { lazy } from "react";
import { Navigate } from "react-router-dom";
import AuthGuard from "./auth/AuthGuard";
import Loadable from "./components/Loadable";
import MatxLayout from "./components/MatxLayout/MatxLayout";
import materialRoutes from "app/views/material-kit/MaterialRoutes";

const Finance = Loadable(lazy(() => import("app/views/dashboard/Finances")));
// SESSION PAGES
const NotFound = Loadable(lazy(() => import("app/views/sessions/NotFound")));
const JwtLogin = Loadable(lazy(() => import("app/views/sessions/JwtLogin")));
const JwtRegister = Loadable(lazy(() => import("app/views/sessions/JwtRegister")));
const ForgotPassword = Loadable(lazy(() => import("app/views/sessions/ForgotPassword")));
const Logout = Loadable(lazy(() => import("app/views/sessions/Logout")));

// E-CHART PAGE
// const AppEchart = Loadable(lazy(() => import("app/views/charts/echarts/AppEchart")));

// const Analytics = Loadable(lazy(() => import("app/views/dashboard/Analytics")));
const Dashboard = Loadable(lazy(() => import("app/views/dashboard/Dashboard")));
const Profile = Loadable(lazy(() => import("app/views/dashboard/Profile")));
const Users = Loadable(lazy(() => import("app/views/dashboard/Users")));
const Orders = Loadable(lazy(() => import("app/views/dashboard/Orders")));
const Admins = Loadable(lazy(() => import("app/views/dashboard/Admins")));
const Projects = Loadable(lazy(() => import("app/views/dashboard/Projects")));
const Products = Loadable(lazy(() => import("app/views/dashboard/Products")));
const News = Loadable(lazy(() => import("app/views/dashboard/News")));
const Campaigns = Loadable(lazy(() => import("app/views/dashboard/Campaigns")));
const Missions = Loadable(lazy(() => import("app/views/dashboard/Missions")));

const StudentDetailForm = Loadable(lazy(() => import("app/views/material-kit/forms/StudentForms/StudentDetailForm")));
const Courses = Loadable(lazy(() => import("app/views/dashboard/Courses")));
const CoursesForms = Loadable(lazy(() => import("app/views/material-kit/forms/AddCourse")));
const ProgramForm = Loadable(lazy(() => import("app/views/material-kit/forms/AddProgram")));
const ProgramDetailForm = Loadable(lazy(() => import("app/views/material-kit/forms/ProgramForms/ProgramDetailForm")));
const StudentForm = Loadable(lazy(() => import("app/views/material-kit/forms/AddStudent")));
const FinanceForm = Loadable(lazy(() => import("app/views/material-kit/forms/FinanceForm2")));

const routes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      ...materialRoutes,
      { path: "/dashboard/home", element: <Dashboard /> },
      { path: "/dashboard/profile", element: <Profile /> },
      { path: "/dashboard/users", element: <Users /> },
      { path: "/dashboard/orders", element: <Orders /> },
      { path: "/dashboard/admins", element: <Admins /> },
      { path: "/dashboard/projects", element: <Projects /> },
      { path: "/dashboard/products", element: <Products /> },
      { path: "/dashboard/news", element: <News /> },
      { path: "/dashboard/campaigns", element: <Campaigns /> },
      { path: "/dashboard/missions", element: <Missions /> },
      { path: "/dashboard/studentform", element: <StudentForm /> },
      { path: "/dashboard/programform", element: <ProgramForm /> },
      { path: "/dashboard/courses", element: <Courses /> },
      { path: "/dashboard/coursesform", element: <CoursesForms /> },
      { path: "/dashboard/finance", element: <Finance /> },
      { path: "/dashboard/financeform", element: <FinanceForm /> },
      { path: "/student/:id", element: <StudentDetailForm /> },
      { path: "/program/:id", element: <ProgramDetailForm /> },
    ]
  },
  { path: "/session/404", element: <NotFound /> },
  { path: "/session/signin", element: <JwtLogin /> },
  { path: "/session/signup", element: <JwtRegister /> },
 
  { path: "/session/forgot-password", element: <ForgotPassword /> },
  { path: "/", element: <Navigate to="/dashboard/home" /> },
  { path: "*", element: <Navigate to="/session/404" /> },
  { path: "/session/logout", element: <Logout/> }
  
];

export default routes;
